import bg_final from "../../Assets/bg_final.png";
import * as S from "./FinalCtaSection.styles";

export const FinalCtaSection = () => {
  return (
    <S.Wrapper
      style={{
        backgroundImage: `url(${bg_final})`,
      }}
    >
      <S.Card
        style={{
          zIndex: "1",
        }}
      >
        <S.CardH2>Let's Build Your Brazil Strategy</S.CardH2>

        <S.CardP>
          Talk to our team and discover how to launch, grow, and scale in one of
          the world's most exciting digital economies.
        </S.CardP>

        {/* <S.Btn
          onClick={() =>
            window.open(
              "https://wa.me/5541999920109?text=Hello%2C%20I%20would%20like%20more%20information.",
              "_blank"
            )
          }
        >
          Unlock Brazil Now
        </S.Btn> */}
      </S.Card>
      <S.CardBlur></S.CardBlur>
    </S.Wrapper>
  );
};
